<div class="actions-bar" [ngClass]="[this.half !== null ? 'half' : '']">
  <div class="actions-bar__wrapper" [ngClass]="[this.half !== null ? 'half' : '']">
    <ng-content></ng-content>
  </div>
</div>
